import { useEffect } from "react";
import { usePartner } from "../context/PartnerContext";

export default function usePageTitle(title) {
  const { appName, tagline } = usePartner();
  const base = appName || "CrunchAlpha";
  const full = tagline ? `${base} — ${tagline}` : base;
  useEffect(() => {
    document.title = title ? `${title} — ${base}` : full;
    return () => { document.title = full; };
  }, [title, base, full]);
}
